<script lang="ts">
    import Occasion from "../application/models/Occasion.ts";
    import CardHolder from "./CardHolder.svelte";

    export let occasionArray: Array<Occasion>;
    export let manager;

    let displayArray = [];
    $: displayArray = formatOccasionArray(occasionArray);

    function formatOccasionArray(inputArray) {
        let array = [];
        for(let i = 0; i < 56; i++){
            array[i] = [];
        }
        inputArray.forEach(occasion => {
            Array.isArray(array[occasion.startBlock - 28]) ? array[occasion.startBlock - 28].push(occasion) : array[occasion.startBlock - 28] = [];
        });
        return array;
    }
</script>

{#each displayArray as block,i}
    <div class="columns">
        <div class="column">
            {#if block.length > 0}
                <CardHolder on:modalOpen manager={manager} block={block}/>
            {/if}
        </div>
    </div>
{/each}

<style>
    .column{
        min-height: 25px;
        max-height: 25px;
        border-bottom: 1px solid rgba(243, 243, 243, 0.25);
        border-left: 1px solid rgba(243, 243, 243, 0.25);
    }
</style>